module.exports = __webpack_public_path__ + "img/danmachi1.59471147.jpg";